import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import { ApiResponse, LogsResponse } from "../../types/api.types";
import { FilterLogsFormData } from "../../components/FilterLogs";

export const logService = {
  getLogs: async (
    currentPage: number,
    pageSize: number,
    searchFilters?: FilterLogsFormData | null
  ): Promise<LogsResponse> => {
    let params: any = {
      page: currentPage,
      rowPerPage: pageSize,
      search: searchFilters?.search || "",
      level: searchFilters?.level || "",
    };

    if (searchFilters?.dateFrom) {
      params.dateFrom = searchFilters.dateFrom;
    }
    if (searchFilters?.dateTo) {
      params.dateTo = searchFilters.dateTo;
    }

    const response = await apiClient.get<ApiResponse<LogsResponse>>(
      ENDPOINTS.LOGS.GET_ALL,
      {
        params,
      }
    );
    return response.data.data;
  },
};
